var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChessWhiteN(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 632 834",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-189,-70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chess_whiteN",
    d: "M557,93L333,94C333,94 371.575,128.366 369,168C366.425,207.634 222.01,373.937 218,409C214.311,441.251 187.695,536.929 300,528C397.687,475.451 489.904,407.099 500,425C510.096,442.901 538.919,437.521 443,564C385.115,640.327 310.07,708.939 306,770C278.89,769.341 285.666,769.23 257,770C203.23,771.445 197.966,880.903 260,881C331.672,881.112 710.341,879.5 757,880C808.497,880.552 816.312,770.273 748,771C718.345,691.007 778.167,567.723 776,422C774.725,336.26 764.784,96.207 557,93Z",
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: "45.83px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChessWhiteN);
export default __webpack_public_path__ + "static/media/chess_whiteN.244f2a17e125215be1838d0bed1981be.svg";
export { ForwardRef as ReactComponent };